import { forwardRef, type ChangeEvent } from 'react'

export interface HiddenFileInputProps {
  accept?: string
  multiple?: boolean
  disabled?: boolean
  onFiles: (files: FileList) => void
  testId?: string
}

export const HiddenFileInput = forwardRef<HTMLInputElement, HiddenFileInputProps>(
  function HiddenFileInput({ accept, multiple, disabled, onFiles, testId }, ref) {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files
      try {
        if (files && files.length >= 1) {
          onFiles(files)
        }
      } finally {
        event.target.value = ''
      }
    }

    return (
      <input
        ref={ref}
        type="file"
        hidden
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        data-testid={testId}
        onChange={handleChange}
      />
    )
  },
)
